// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__3lXYp","logo":"MainNavigation_logo__2K-rO","nav":"MainNavigation_nav__kEgTy","active":"MainNavigation_active__2NnEb"};